export enum UserDefinedDataType {
	Decimal = 1,
	String = 2,
	LongString = 3,
	Date = 4,
	DateTime = 5,
}